export const commonTranslationsPl = {
    appName: 'TSR BackOffice',
    columns: 'Kolumny',
    loginStatusLogout: 'Wyloguj',
    loggedUserAccountSettings: 'Ustawienia użytkownika',
    commonSessionHasExpired: 'Sesja wygasła.',
    appLoadingApplicationIntialization: 'Ładowanie...',
    commonSelectAll: 'Zaznacz wszystkie pozycje',
    commonSearch: 'Szukaj..',
    commonSelected: 'Zaznaczono',
    commonAdd: 'Dodaj',
    commonDelete: 'Usuń',
    commonEdit: 'Edytuj',
    commonUpdate: 'Aktualizuj',
    commonYes: 'Tak',
    commonNo: 'Nie',
    sharedComponentsClose: 'Zamknij',
    User: 'Użytkownik',
    Admin: 'Administrator',
    reportsSearchPlaceholder: 'Wyszukaj...',
    reportsSelectAll: 'Zaznacz wszystkie pozycje',
    defaultEmpty: '(puste)',
    gridMenuResetfilters: 'Resetuj filtry',
    gridMenuResetTableState: 'Przywróć domyślny stan tabeli',
    dataAnalysisCloseAllTabs: 'Zamknij wszystkie zakładki',
};

export const commonTranslationsEn = {
    appName: 'TSR BackOffice',
    columns: 'columns',
    loginStatusLogout: 'Logout',
    loggedUserAccountSettings: 'User settings',
    commonSessionHasExpired: 'Session has expired.',
    appLoadingApplicationIntialization: 'Loading...',
    commonSelectAll: 'Select all',
    commonSearch: 'Search..',
    commonSelected: 'Selected',
    commonAdd: 'Add',
    commonDelete: 'Delete',
    commonEdit: 'Edit',
    commonUpdate: 'Update',
    commonYes: 'Yes',
    commonNo: 'No',
    sharedComponentsClose: 'Close',
    User: 'User',
    Admin: 'Admin',
    reportsSearchPlaceholder: 'Search...',
    reportsSelectAll: 'Select all',
    defaultEmpty: '(empty)',
    gridMenuResetfilters: 'Reset filters',
    gridMenuResetTableState: 'Restore default table state',
    dataAnalysisCloseAllTabs: 'Close all tabs',
};
